import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { ErrorMessage, IsLoading } from '../../components/LoadingOrErrorCollection'
import { Collection, CollectionItem, Photo } from '../Collection'
import { Tools, ToolsButtons } from '../../components/CollectionWallpapers/theme'
import UploadImage from '../UploadImage'
import { shouldRender } from '../../utils'
import {mapImageUrl} from "../../utils/mapImageUrl";

const CollectionPhotos = ({
  isLoading,
  errMessage,
  photos = [],
  withUpload,
  onClick,
  onDrop,
  photoIsSelected = false,
  selectedIndex,
  action,
}) => (
  <Fragment>
    <IsLoading isLoading={isLoading} />
    <ErrorMessage errMessage={errMessage} />

    {shouldRender(errMessage, isLoading) && (
      <Collection>
        {withUpload === true && (
          <CollectionItem>
            <UploadImage key={'upload-image'} onDrop={onDrop} />
          </CollectionItem>
        )}

        {photos.map(photo => (
          <CollectionItem key={photo.src}>
            <Photo className={'loading-img'} src={photo.src} onClick={() => onClick(photo.index)} />
            <Tools isActive={selectedIndex === photo.index}>
              {photoIsSelected && (
                <ToolsButtons onClick={stopPropagation(() => action.select(photo.index))}>Wybierz</ToolsButtons>
              )}
              <ToolsButtons onClick={stopPropagation(() => action.remove(photo.index))}>Usuń</ToolsButtons>
            </Tools>
          </CollectionItem>
        ))}
      </Collection>
    )}
  </Fragment>
)

CollectionPhotos.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  errMessage: PropTypes.string.isRequired,
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      index: PropTypes.number.isRequired,
    })
  ).isRequired,
  withUpload: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
}

export default CollectionPhotos

const stopPropagation = cb => e => {
  e.stopPropagation()
  return cb(e)
}



// WEBPACK FOOTER //
// ./src/components/CollectionPhotos/index.js